import {AddressCreateDto, AddressUpdateDto} from "../../../api";
import {CrudFormItemProps, CrudFormModal, nameof} from "digimuth-components/dist";
import BuildingFlatNumber
    , {buildingAndFlat} from "../../../components/formComponents/buildingFlatNumber/buildingFlatNumber";
import PostalCode from "../../../components/formComponents/postalCode/postalCode";

const layout = {
    labelCol: {span: 12},
    wrapperCol: {span: 24},
    layout: "vertical",
};

export default function AddressModalForm(props: AddressModalProps) {
    const formItems: CrudFormItemProps[] = [
        {
            name: nameof<AddressCreateDto>("street"),
            label: "Ulica",
            rules: [
                {required: true, message: 'To pole jest wymagane'}
            ]
        },
        {
            name: "buildingAndFlatNumber",
            label: "Numer budynku/mieszkania",
            children: <BuildingFlatNumber initialValues={{
                building: props.initialValues?.buildingNumber ?? "",
                flat: props.initialValues?.flatNumber ?? ""
            }}/>,
            rules: [
                {
                    validator: (_, value: buildingAndFlat | null) => {
                        if (props.initialValues?.flatNumber || props.initialValues?.buildingNumber)
                            return Promise.resolve();

                        if (!value || (!value.building && !value.flat))
                            return Promise.reject("To pole jest wymagane");
                        if (!value.building && value.flat)
                            return Promise.reject("Number budynku jest wymagany");

                        return Promise.resolve();
                    }
                }
            ]
        },
        {
            name: nameof<AddressCreateDto>("postalCode"),
            label: "Kod pocztowy",
            rules: [
                {required: true, message: 'To pole jest wymagane'},
                {pattern: new RegExp('^[0-9]{2}-[0-9]{3}$'), message: 'To pole jest wymagane w formacie XX-XXX'}
            ],
            children: <PostalCode initialValues={props.initialValues?.postalCode}/>
        },
        {
            name: nameof<AddressCreateDto>("city"),
            label: "Miasto",
            rules: [
                {required: true, message: 'To pole jest wymagane'}
            ]
        },
        {
            name: nameof<AddressCreateDto>("vatId"),
            label: "NIP",
            rules: [
                {
                    pattern: new RegExp('^[0-9]{10}$|^$'),
                    message: 'To pole jest wymagane w formacie XXXXXXXXXX'
                }
            ]
        },
        {
            name: nameof<AddressCreateDto>("companyName"),
            label: "Firma"
        },
    ];

    const onSubmit = async (value: any) => {
        await props.onSubmit({
            ...value,
            "buildingNumber": value.buildingAndFlatNumber?.building ?? props.initialValues?.buildingNumber,
            "flatNumber": value.buildingAndFlatNumber?.flat ?? props.initialValues?.flatNumber
        });
    }

    return <CrudFormModal
        formItems={formItems}
        forceRender={true}
        destroyOnClose={true}
        onSubmit={onSubmit}
        onModalCancelClicked={() => props.setModalVisibility(false)}
        initialValues={props.initialValues}
        modalOkText={props.saveButtonTitle}
        modalTitle={props.modalTitle}
        isModalVisible={props.isModalVisible}
        modalCancelText={"Anuluj"}
        formProps={layout}
        width={500}
    />;
}

interface AddressModalProps {
    initialValues?: AddressCreateDto | AddressUpdateDto,
    isModalVisible: boolean;
    setModalVisibility: (isVisible: boolean) => any;
    onSubmit: (value: AddressCreateDto | AddressUpdateDto) => Promise<any>,
    modalTitle: string,
    saveButtonTitle: string,
}
